<template>
  <div
    class="modal fade"
    :id="'changePasswordDialog' + _uid"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <!-- Close button in the upper right corner -->
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <!-- Modal title -->
          <h4 class="modal-title">
            <b>{{ lang.PW0014 }}</b>
          </h4>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
            <form
              class="form-horizontal"
              @keyup.enter="checkIfNewPasswordPassed()"
            >
              <!-- input old password -->
              <div class="form-group">
                <label
                  :for="'inputOldPassword' + _uid"
                  class="col-md-4 control-label"
                  >{{ lang.PW0013 }}</label
                >
                <div class="col-md-8">
                  <input
                    type="password"
                    class="form-control"
                    :id="'inputOldPassword' + _uid"
                    v-model="passwords.oldPassword"
                  />
                </div>
              </div>
              <!-- input new password -->
              <div class="form-group">
                <label
                  :for="'inputNewPassword' + _uid"
                  class="col-md-4 control-label"
                  >{{ lang.PW0001 }}</label
                >
                <div class="col-md-8">
                  <input
                    type="password"
                    class="form-control"
                    :id="'inputNewPassword' + _uid"
                    v-model="passwords.newPassword"
                    @input="doCheckIfPasswordIsValid(), checkIfPasswordsMatch()"
                  />
                </div>
              </div>
              <!-- repeat new password -->
              <div class="form-group" style="padding-bottom: 2px">
                <label
                  :for="'inputNewPasswordRepeat' + _uid"
                  class="col-md-4 control-label"
                  >{{ lang.PW0002 }}</label
                >
                <div class="col-md-8">
                  <input
                    type="password"
                    class="form-control"
                    :id="'inputNewPasswordRepeat' + _uid"
                    v-model="passwords.newPasswordRepeat"
                    @input="checkIfPasswordsMatch()"
                  />
                </div>
              </div>
            </form>
          </div>
          <!-- show policies and validations -->
          <div id="passwordPolicy" class="col-md-12">
            <p>
              <b>{{ lang.PW0003 }}</b>
            </p>
            <table
              class="table table-bordered"
              v-if="passwordPolicy.length > 0"
            >
              <tbody>
                <tr>
                  <td class="nopadding width-20">
                    <i
                      class="material-icons md-24 text-red"
                      v-if="!passwordValidity.enoughCharacters"
                      >clear</i
                    >
                    <i class="material-icons md-24 text-green" v-else>done</i>
                  </td>
                  <td class="width-80">
                    {{ lang.PW0004 }} {{ passwordPolicy[0].value }}
                    {{ lang.PW0005 }}
                  </td>
                </tr>
                <tr>
                  <td class="nopadding width-20">
                    <i
                      class="material-icons md-24 text-red"
                      v-if="!passwordValidity.hasUpperCase"
                      >clear</i
                    >
                    <i class="material-icons md-24 text-green" v-else>done</i>
                  </td>
                  <td class="width-80">
                    {{ lang.PW0004 }} {{ passwordPolicy[1].value }}
                    {{ lang.PW0006 }}
                  </td>
                </tr>
                <tr>
                  <td class="nopadding width-20">
                    <i
                      class="material-icons md-24 text-red"
                      v-if="!passwordValidity.hasLowerCase"
                      >clear</i
                    >
                    <i class="material-icons md-24 text-green" v-else>done</i>
                  </td>
                  <td class="width-80">
                    {{ lang.PW0004 }} {{ passwordPolicy[2].value }}
                    {{ lang.PW0007 }}
                  </td>
                </tr>
                <tr>
                  <td class="nopadding width-20">
                    <i
                      class="material-icons md-24 text-red"
                      v-if="!passwordValidity.hasNumbers"
                      >clear</i
                    >
                    <i class="material-icons md-24 text-green" v-else>done</i>
                  </td>
                  <td class="width-80">
                    {{ lang.PW0004 }} {{ passwordPolicy[3].value }}
                    {{ lang.PW0008 }}
                  </td>
                </tr>
                <tr>
                  <td class="nopadding width-20">
                    <i
                      class="material-icons md-24 text-red"
                      v-if="!passwordValidity.hasNonalphas"
                      >clear</i
                    >
                    <i class="material-icons md-24 text-green" v-else>done</i>
                  </td>
                  <td class="width-80">
                    {{ lang.PW0004 }} {{ passwordPolicy[4].value }}
                    {{ lang.PW0009 }}
                  </td>
                </tr>
                <tr>
                  <td class="nopadding width-20">
                    <i
                      class="material-icons md-24 text-red"
                      v-if="!passwordsMatch"
                      >clear</i
                    >
                    <i class="material-icons md-24 text-green" v-else>done</i>
                  </td>
                  <td class="width-80">{{ lang.PW0012 }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <!-- Add modal buttons here -->
          <button
            type="button"
            class="btn btn-raised btn-default"
            data-dismiss="modal"
          >
            {{ lang.PW0010 }}
          </button>
          <button
            type="button"
            class="btn btn-raised dialog-btn-primary"
            @click="checkIfNewPasswordPassed()"
            :disabled="!isPasswordValid || !passwordsMatch"
          >
            {{ lang.PW0011 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChangePasswordDialog",
  props: {
    showDialog: {
      default: false,
      type: Boolean,
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#changePasswordDialog" + this._uid).on("hide.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });
    this.globals.getPasswordPolicyList((callbackData) => {
      this.passwordPolicy = callbackData;
    });
    this.debouncedCheckPasswordValidity = _.debounce(
      this.validatePassword,
      500
    );
    this.openChangePasswordDialog();
  },
  watch: {
    showDialog() {
      this.showDialog
        ? this.openChangePasswordDialog()
        : this.closeChangePasswordDialog();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  data() {
    return {
      passwordsMatch: false,
      isPasswordValid: false,
      passwordPolicy: [],
      passwordValidity: {},
      passwords: {
        oldPassword: "",
        newPassword: "",
        newPasswordRepeat: "",
      },
      lang: {
        PW0000: "Reset password",
        PW0001: "New password",
        PW0002: "Change new password",
        PW0003: "Password policies",
        PW0004: "at least",
        PW0005: "letters",
        PW0006: "capital letter(s)",
        PW0007: "small letter(s)",
        PW0008: "numeral(s)",
        PW0009: "special character(s)",
        PW0010: "Cancel",
        PW0011: "Save",
        PW0012: "Passwords match",
        PW0013: "Old password",
        PW0014: "Change password",
        PW0015: "Old password missing",
        PW0016: "Password changed",
      },
    };
  },
  methods: {
    openChangePasswordDialog() {
      $("#changePasswordDialog" + this._uid).modal("show");
      this.initChangePasswordDialog();
    },
    closeChangePasswordDialog() {
      $("#changePasswordDialog" + this._uid).modal("hide");
    },
    initChangePasswordDialog() {
      this.passwordsMatch = false;
      this.isPasswordValid = false;
      this.passwordValidity = {};
      this.passwords = {
        oldPassword: "",
        newPassword: "",
        newPasswordRepeat: "",
      };
    },
    doCheckIfPasswordIsValid() {
      if (this.debouncedCheckPasswordValidity)
        this.debouncedCheckPasswordValidity();
    },
    validatePassword() {
      let passwordToCheck = {
        Password: this.passwords.newPassword,
      };
      $.ajax({
        method: "POST",
        url: "api/Password/ValidatePassword",
        data: JSON.stringify(passwordToCheck),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.passwordValidity = data;
          this.checkPasswordValidity();
        },
        error: () => {
          console.error("Error on POST in validatePassword()");
          this.globals.showErrorSnackbar("Password validation failed");
        },
      });
    },
    checkIfPasswordsMatch() {
      this.passwordsMatch =
        !!this.passwords.newPassword && !!this.passwords.newPasswordRepeat
          ? this.passwords.newPassword === this.passwords.newPasswordRepeat
          : false;
    },
    checkPasswordValidity() {
      this.isPasswordValid =
        _.filter(this.passwordValidity, (value) => !value).length === 0;
    },
    checkIfNewPasswordPassed() {
      if (this.isPasswordValid && this.passwordsMatch) this.saveNewPassword();
    },
    saveNewPassword() {
      let request = "api/Password/ChangePassword";

      if (!this.passwords.oldPassword) {
        this.globals.showErrorSnackbar(this.lang.PW0015);
        return;
      }
      let passwordData = {
        Password: this.passwords.newPassword,
        OldPassword: this.passwords.oldPassword,
      };

      $.ajax({
        method: "PATCH",
        url: request,
        data: JSON.stringify(passwordData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.globals.showSuccessSnackbar(this.lang.PW0016);
          this.closeChangePasswordDialog();
        },
        error: () => {
          console.error("Error on PUT in saveNewPassword()");
          this.globals.showErrorSnackbar("Password update failed");
        },
      });
    },
  },
};
</script>

<style scoped>
#passwordPolicy {
  padding: 15px 0 15px 0;
}

#passwordPolicy table i {
  margin-top: 5px;
}

.width-20 {
  width: 20%;
}
.width-80 {
  width: 80%;
}

@media (max-width: 1000px) {
  #passwordPolicy .md-24 {
    font-size: 2em;
  }
  #passwordPolicy table i {
    margin-top: 10px;
  }
  #passwordPolicy table td {
    padding-top: 0.7em;
    border-width: 3px;
  }
  @media screen and (max-aspect-ratio: 13/9) {
    .modal-dialog {
      width: 100vw;
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ChangePasswordDialog.vue?f9ab65b6